import Vue from 'vue'
import axios from 'axios'
import main from './main'
import cookie from 'js-cookie'
import { router } from './router'
import {
  userTokenKey,
  pdaScreenWidth,
  pdaMessageScanDuration,
  scanMessageDefaultDuration,
  apiLangKey
} from './utils/Config.js'
import Utils from './utils/Utils.js'
const commonApiList = [ // 绕过多语言替换的接口清单
  '/api/project/version',
  '/api/project/time'
]
const isPda = window.screen.availWidth <= pdaScreenWidth
let loadingInstance = null

function closeLoading() {
  if (loadingInstance) {
    loadingInstance.close()
    loadingInstance = null
  }
}

axios.interceptors.request.use(
  config => {
    const token = cookie.get(userTokenKey);
    const routerLangKey = localStorage.getItem(apiLangKey);

    if (!commonApiList.filter(i => config.url.includes(i)).length) {
      config.url = config.url.replace('/api/', `/api/${routerLangKey}/`)
    }
    
    if (token) {
      config.headers = {
        'Authorization': `Bearer ${token}`
      }
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  response => {
    const code = Number(response.data.code)
    const refreshToken = response.data.refresh_token
    const token = cookie.get(userTokenKey)
    if (refreshToken && refreshToken !== token) {
      cookie.set(userTokenKey, refreshToken)
    }
    if(code === 400 || code === 401 || code === 7000){
      cookie.remove(userTokenKey)
      router.replace('/login')
    }

    return response
  },
  error => {
    if (error.response.status === 500) {
      Vue.prototype.$message.error('请求失败')
    }
    return Promise.reject(error)
  }
)

export default (method, url, params = {}, options = {}) => {
  return new Promise((resolve, reject) => {
    const apiBaseUrl = Utils.generateApiUrl()
    params = Object.fromEntries(
        Object.entries(params).filter(([key, value]) => value!== null && value!== undefined && value!== '')
    );
    let query = params
    if (method === 'get') {
      query = { params }
    }

    const loadintText = localStorage.getItem(apiLangKey) === 'en' ? 'Loading...' : '加载中...'

    if (!options || !options.silence) {
      loadingInstance = loadingInstance || Vue.prototype.$loading({
        lock: true,
        text: loadintText,
        fullscreen: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    }

    axios[method](`${apiBaseUrl}${url}`, query)
    .then((res) => {
      if (res) {
        const data = res.data
        const code = Number(data.code)
        if (code === 200) {
          resolve(data.data)
        } else {
          const { keepError } = options
          const duration = isPda ? pdaMessageScanDuration : scanMessageDefaultDuration

          main.$store.dispatch('setApiError', { path: url, msg: data.msg })

          Vue.prototype.$message({
            message: data.msg,
            duration: keepError ? 0 : duration,
            type: keepError ? 'error' : 'info',
            showClose: keepError ? true : false
          })
          
          resolve(null)
        }
        if (data.success_speak_msg) {
          Utils.speak(data.success_speak_msg)
        }

        closeLoading()
      }
    })
    .catch((error) => {
      reject(error)
      closeLoading()
    })
  })
}